import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FlexBox, GradientContainer, Logo,
} from '../../components';
import { Title, Description } from '../../components/typography';
import { Button } from '../../components/buttons';

function CheckoutCancel() {
  const navigate = useNavigate();

  return (
    <GradientContainer>
      <FlexBox alignItems="center">
        <Logo />

        <FlexBox textAlign="center" marginY={5}>
          <Title>Checkout Cancelled</Title>
          <Description>
            You cancelled the checkout process. You can try again anytime.
          </Description>
        </FlexBox>

        <FlexBox width={400} marginY={3}>
          <Button
            onClick={() => navigate('/billing/checkout')}
            label="Try Again"
            large
          />
          <Button
            onClick={() => navigate('/gallery')}
            label="Go to Gallery"
            style={{ marginTop: '1rem' }}
          />
        </FlexBox>
      </FlexBox>
    </GradientContainer>
  );
}

export default CheckoutCancel;

